/**
 * Comparison Table - mobile pill picker.
 *
 * The markup already carries every tier and CSS reveals the one matching
 * `data-active-tier`, so this only moves that attribute. Blocks rendered as a
 * card carousel have no pills and are skipped.
 */

document.addEventListener("DOMContentLoaded", () => {
	const pickers = document.querySelectorAll(".cirrus-comparison-table__picker");

	pickers.forEach((picker) => {
		const tabs = Array.from(picker.querySelectorAll(".cirrus-comparison-table__tab"));

		if (tabs.length < 2) {
			return;
		}

		const select = (index) => {
			picker.setAttribute("data-active-tier", String(index));

			tabs.forEach((tab) => {
				tab.setAttribute(
					"aria-pressed",
					tab.getAttribute("data-tier") === String(index) ? "true" : "false"
				);
			});
		};

		tabs.forEach((tab, position) => {
			tab.addEventListener("click", () => {
				select(Number(tab.getAttribute("data-tier")));
			});

			tab.addEventListener("keydown", (event) => {
				const offset = { ArrowLeft: -1, ArrowRight: 1 }[event.key];

				if (!offset) {
					return;
				}

				event.preventDefault();

				const next = tabs[(position + offset + tabs.length) % tabs.length];
				next.focus();
				select(Number(next.getAttribute("data-tier")));
			});
		});
	});
});
